module.exports = __webpack_public_path__ + "static/media/german-flag.09ab656e.svg";